import React, { useState } from 'react'
import { Phone, Mail, Clock, Plus, Minus } from 'lucide-react'

const WHATSAPP_NUMBER = '554396659096'

const SERVICE_OPTIONS = [
  'Branding & Identidade Visual',
  'Mídias Sociais',
  'Tráfego Pago',
  'Sites & E-commerces',
  'Produção Audiovisual',
  'SEO Estratégico',
  'Não sei ainda',
]

const BUDGET_OPTIONS = [
  'Até R$ 2.000/mês',
  'R$ 2.000 – R$ 5.000/mês',
  'R$ 5.000 – R$ 10.000/mês',
  'R$ 10.000 – R$ 20.000/mês',
  'Acima de R$ 20.000/mês',
  'Projeto pontual',
]

const FAQ = [
  {
    q: 'Como funciona o diagnóstico estratégico gratuito?',
    a: 'Preenchendo o formulário, você é direcionado direto para o nosso WhatsApp com sua solicitação já pronta. É só enviar e nossa equipe agenda a conversa para entender seu negócio, seus desafios e indicar o melhor caminho estratégico.',
  },
  {
    q: 'Qual é o prazo para iniciar um projeto?',
    a: 'Após o diagnóstico e aprovação da proposta, o projeto costuma iniciar em até 7 dias úteis, dependendo do escopo e da disponibilidade de agenda.',
  },
  {
    q: 'A Dorac atende empresas de todo o Brasil?',
    a: 'Sim. Atendemos clientes em todo o Brasil de forma 100% remota, com reuniões online e acompanhamento contínuo.',
  },
  {
    q: 'Vocês trabalham com contratos de quanto tempo?',
    a: 'Trabalhamos com contratos mensais recorrentes e também com projetos pontuais, dependendo da necessidade e do objetivo do cliente.',
  },
]

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false)
  return (
    <div className='border-b border-dorac-border py-4'>
      <button onClick={() => setOpen(!open)} className='flex w-full items-center justify-between gap-4 text-left'>
        <span className='font-semibold text-dorac-ink'>{q}</span>
        {open ? (
          <Minus className='h-4 w-4 flex-shrink-0 text-dorac-purple' />
        ) : (
          <Plus className='h-4 w-4 flex-shrink-0 text-dorac-purple' />
        )}
      </button>
      {open && <p className='mt-3 text-sm leading-relaxed text-dorac-ink/60'>{a}</p>}
    </div>
  )
}

function ContactContent() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    whatsapp: '',
    company: '',
    service: '',
    budget: '',
    message: '',
  })
  const [status, setStatus] = useState({ state: 'idle', message: '' })

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData((prev) => ({ ...prev, [id]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!formData.fullName || !formData.email) {
      setStatus({ state: 'error', message: 'Preencha ao menos nome e e-mail.' })
      return
    }

    const lines = [
      'Olá, vim pelo site e gostaria de solicitar um diagnóstico estratégico gratuito!',
      '',
      `Nome: ${formData.fullName}`,
      `E-mail: ${formData.email}`,
      formData.whatsapp && `WhatsApp: ${formData.whatsapp}`,
      formData.company && `Empresa: ${formData.company}`,
      formData.service && `Serviço de interesse: ${formData.service}`,
      formData.budget && `Investimento estimado: ${formData.budget}`,
      formData.message && `Sobre o negócio: ${formData.message}`,
    ].filter(Boolean)

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(
      lines.join('\n'),
    )}`

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer')

    setStatus({
      state: 'success',
      message: `Perfeito, ${formData.fullName.split(' ')[0]}! Abrimos o WhatsApp com sua solicitação, é só enviar a mensagem.`,
    })
  }

  return (
    <>
      <section className='dorac-grid-bg pb-16 pt-32'>
        <div className='container mx-auto max-w-3xl px-4 text-center'>
          <span className='mb-3 block text-xs font-bold uppercase tracking-widest text-dorac-purple'>
            Vamos conversar
          </span>
          <h1 className='section-title mb-6'>Solicite seu diagnóstico estratégico</h1>
          <p className='text-base leading-relaxed text-dorac-ink/60 md:text-lg'>
            Preencha o formulário abaixo e fale direto com a nossa equipe pelo WhatsApp para agendar sua conversa
            estratégica gratuita.
          </p>
        </div>
      </section>

      <section className='bg-white py-16'>
        <div className='container mx-auto px-4'>
          <div className='mx-auto grid max-w-5xl grid-cols-1 gap-10 lg:grid-cols-3'>
            <div className='flex flex-col gap-6'>
              <div>
                <span className='mb-1 block text-xs font-bold uppercase tracking-widest text-dorac-ink/40'>
                  WhatsApp
                </span>
                <a
                  href='https://api.whatsapp.com/send?phone=554396659096'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex items-center gap-2 font-semibold text-dorac-ink transition-colors hover:text-dorac-purple'
                >
                  <Phone className='h-4 w-4 text-dorac-purple' />
                  (43) 9665-9096
                </a>
              </div>
              <div>
                <span className='mb-1 block text-xs font-bold uppercase tracking-widest text-dorac-ink/40'>E-mail</span>
                <a
                  href='mailto:comercial@dorac.com.br'
                  className='flex items-center gap-2 font-semibold text-dorac-ink transition-colors hover:text-dorac-purple'
                >
                  <Mail className='h-4 w-4 text-dorac-purple' />
                  comercial@dorac.com.br
                </a>
              </div>
              <div>
                <span className='mb-1 block text-xs font-bold uppercase tracking-widest text-dorac-ink/40'>
                  Horário de atendimento
                </span>
                <span className='flex items-center gap-2 font-semibold text-dorac-ink'>
                  <Clock className='h-4 w-4 text-dorac-purple' />
                  Seg–Sex, 8h às 18h
                </span>
              </div>
            </div>

            <form onSubmit={handleSubmit} className='flex flex-col gap-4 lg:col-span-2'>
              <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>Nome completo *</label>
                  <input
                    id='fullName'
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    className='w-full rounded-lg border border-dorac-border px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  />
                </div>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>E-mail *</label>
                  <input
                    id='email'
                    type='email'
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className='w-full rounded-lg border border-dorac-border px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  />
                </div>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>WhatsApp</label>
                  <input
                    id='whatsapp'
                    value={formData.whatsapp}
                    onChange={handleChange}
                    className='w-full rounded-lg border border-dorac-border px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  />
                </div>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>Empresa</label>
                  <input
                    id='company'
                    value={formData.company}
                    onChange={handleChange}
                    className='w-full rounded-lg border border-dorac-border px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  />
                </div>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>Serviço de interesse</label>
                  <select
                    id='service'
                    value={formData.service}
                    onChange={handleChange}
                    className='w-full rounded-lg border border-dorac-border bg-white px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  >
                    <option value=''>Selecione um serviço</option>
                    {SERVICE_OPTIONS.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className='mb-1 block text-sm font-semibold text-dorac-ink'>
                    Investimento mensal estimado
                  </label>
                  <select
                    id='budget'
                    value={formData.budget}
                    onChange={handleChange}
                    className='w-full rounded-lg border border-dorac-border bg-white px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                  >
                    <option value=''>Selecione uma faixa</option>
                    {BUDGET_OPTIONS.map((b) => (
                      <option key={b} value={b}>
                        {b}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label className='mb-1 block text-sm font-semibold text-dorac-ink'>
                  Conte um pouco sobre o seu negócio e desafios
                </label>
                <textarea
                  id='message'
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className='w-full resize-none rounded-lg border border-dorac-border px-4 py-3 text-sm outline-none focus:border-dorac-purple'
                />
              </div>

              <button type='submit' className='btn-dorac self-start px-8 py-4 text-base'>
                Solicitar diagnóstico gratuito
              </button>

              {status.state !== 'idle' && (
                <p className={`text-sm ${status.state === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                  {status.message}
                </p>
              )}

              <p className='text-xs text-dorac-ink/40'>
                Ao enviar, você concorda com nossa Política de Privacidade. Não enviamos spam.
              </p>
            </form>
          </div>
        </div>
      </section>

      <section className='dorac-grid-bg py-24'>
        <div className='container mx-auto max-w-2xl px-4'>
          <h2 className='section-title mb-10 text-center'>Dúvidas frequentes</h2>
          <div>
            {FAQ.map((item) => (
              <FaqItem key={item.q} {...item} />
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default ContactContent
